import { createSelector } from '@reduxjs/toolkit'
export const SLICE_NAME = 'ledgerReport'
const select = (state: any) => state[SLICE_NAME]
export const getLedgerReportData = createSelector(
  select,
  ledgerReport => ledgerReport.report
)
